import { Model } from '../Model.js';

var _dec, _class;

/**
 * Enum type representing archive time options.
 *
 */
let ArchiveTimeType = /*#__PURE__*/function (ArchiveTimeType) {
  ArchiveTimeType["ONEWEEK"] = "ONEWEEK";
  ArchiveTimeType["TWOWEEKS"] = "TWOWEEKS";
  ArchiveTimeType["MONTH"] = "MONTH";
  ArchiveTimeType["NEVER"] = "NEVER";
  return ArchiveTimeType;
}({});

/**
 * Plain object ArchiveTime representation.
 *
 */

/**
 * Serialized object ArchiveTime representation.
 *
 */

/**
 * Plain object Packlink's API response representation.
 *
 */

let ArchiveTime = (_dec = Model(), _dec(_class = class ArchiveTime {
  /**
   * Takes a IArchiveTimeApiResponse from Packlink's API and returns a ArchiveTime.
   *
   * @param response  IArchiveTimeApiResponse response from Packlink's API.
   *
   */
  static createFromResponse(response) {
    return new ArchiveTime(ArchiveTimeType[response.active], response.options);
  }

  /**
   * Takes a serialized ArchiveTime and returns a ArchiveTime.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized ArchiveTime.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedArchiveTime.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of ArchiveTime.
   *
   */

  /**
   * Takes a serialized ArchiveTime and returns a ArchiveTime.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized ArchiveTime.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedArchiveTime.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of ArchiveTime.
   *
   */

  /**
   * Takes a serialized ArchiveTime and returns a ArchiveTime.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized ArchiveTime.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedArchiveTime.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of ArchiveTime.
   *
   */

  /**
   * Takes a serialized ArchiveTime and returns a ArchiveTime.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized ArchiveTime.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedArchiveTime.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of ArchiveTime.
   *
   */
  static deserialize(data) {
    if (!data) {
      return;
    }
    return new ArchiveTime(data.active, data.options);
  }

  /**
   * Returns a new ArchiveTime. Typings of the properties depend on the class type param T
   *
   */
  constructor(active, options) {
    this.active = active;
    this.options = options;
  }

  /**
   * Returns a JSON serialized version of the ArchiveTime.
   *
   */
  toJSON() {
    return {
      active: this.active,
      options: this.options
    };
  }

  /**
   * Returns a clone of the ArchiveTime.
   *
   */
  clone() {
    var _this$options;
    return new ArchiveTime(this.active, (_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.map(el => el));
  }

  /**
   * Returns whether the two ArchiveTime are equal.
   *
   */
  equals(archiveTime) {
    var _this$options2;
    if (!archiveTime) {
      return false;
    }
    return this.active === archiveTime.active && ((_this$options2 = this.options) === null || _this$options2 === void 0 ? void 0 : _this$options2.find((parcel, key) => {
      var _archiveTime$options;
      return parcel !== ((_archiveTime$options = archiveTime.options) === null || _archiveTime$options === void 0 ? void 0 : _archiveTime$options[key]);
    })) === undefined;
  }
}) || _class);

export { ArchiveTime, ArchiveTimeType };
//# sourceMappingURL=ArchiveTime.js.map
